import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    text: '',
    showFeatured: false,
}

const filterSlice = createSlice({
    initialState,
    name: 'filter',
    reducers: {
        setText: (state, action) => {
            state.text = action.payload
        },
        setShowFeatured: (state, action) => {
            state.showFeatured = action.payload
        },
    }
})
export const { setText, setShowFeatured } = filterSlice.actions

export default filterSlice.reducer;
